import { createContext } from 'react';

export const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  // https://retailxpress.herokuapp.com/api/v1
  //http://localhost:1445/api/v1
  // http://143.198.155.229/api/v1
  // https://admin.retailxpress.africa/api/v1
  // https://stageback.flexdeals.com.ng/api/v1
  // https://admin.flexdeals.com.ng/api/v1

  let BASE_URL;
  if (window.location.hostname === 'dashboard.flexdeals.com.ng') {
    BASE_URL = 'https://admin.flexdeals.com.ng/api/v1';
  } else {
    BASE_URL = 'http://167.99.237.52:8000/api/v1';
  }
  
  return (
    <BaseUrlContext.Provider value={ BASE_URL}>
      {children}
    </BaseUrlContext.Provider>
  );
};


